import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    return (
        <footer role="contentinfo" className="bg-white border-t border-gray-100 pt-20 pb-12">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16 text-center md:text-left">
                    {/* Brand Section */}
                    <div className="flex flex-col items-center md:items-start">
                        <p className="text-2xl font-serif font-bold text-primary mb-6">KUNSTLOUNGE</p>
                        <p className="text-gray-500 text-sm leading-relaxed max-w-xs font-light">
                            Exclusieve toegang tot de privécollectie van Clemens Briels. Een curator van passie, kleur en Antipodisme.
                        </p>
                    </div>

                    {/* Navigation */}
                    <nav aria-label="Footer navigatie" className="flex flex-col items-center">
                        <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-primary mb-6">Verken</p>
                        <ul className="space-y-4 text-sm tracking-wide text-gray-500 uppercase text-center">
                            <li><Link to="/" className="hover:text-accent transition-colors duration-300">Home</Link></li>
                            <li><Link to="/antipodisme" className="hover:text-accent transition-colors duration-300">Antipodisme</Link></li>
                            <li><Link to="/symboliek" className="hover:text-accent transition-colors duration-300">Symboliek</Link></li>
                            <li><Link to="/#collectie" className="hover:text-accent transition-colors duration-300">De Collectie</Link></li>
                            <li><Link to="/over-ons" className="hover:text-accent transition-colors duration-300">Over Ons</Link></li>
                        </ul>
                    </nav>

                    {/* Contact/AEO Section */}
                    <div className="flex flex-col items-center md:items-end">
                        <p className="text-[10px] font-bold tracking-[0.2em] uppercase text-primary mb-6">Persoonlijk Contact</p>
                        <p className="text-sm text-gray-500 mb-2 font-light italic text-center md:text-right">Voor verzamelaars & fijnproevers</p>
                        <Link to="/aanvraag" className="text-[10px] uppercase tracking-widest text-primary border-b border-gray-100 hover:text-accent hover:border-accent pb-1 transition-all">Stuur een Bericht</Link>
                    </div>
                </div>

                <div className="pt-12 border-t border-gray-50 text-center">
                    <p className="text-gray-400 text-[10px] tracking-widest font-light uppercase">
                        &copy; {new Date().getFullYear()} Kunstlounge. Alle rechten voorbehouden.
                        <span className="mx-4 text-gray-200" aria-hidden="true">|</span>
                        <a href="/privacy-policy.html" className="hover:text-primary transition-colors">Privacy Policy</a>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;